<ng-container *transloco="let t; read: 'time-entries'" >
    <ng-container *ngIf="vm$ | async as vm">
    <kendo-grid
    [data]="gridData"
    [sortable]="sortable ? sortSettings : false"
    [sort]="sort"
    (sortChange)="onSortChange($event)"
    [pageable]="pageable"
    [skip]="gridState.skip"
    [pageSize]="gridState.pageSize"
    (pageChange)="onPageChange($event)"
    scrollable="none"
  >
    <kendo-grid-column
     media="(min-width: 450px)" [title]="t('date')" field="date">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.date | date: "EE dd.MM.yyyy"}}
      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalWorkTimeObj || totalFlexTimeChangeObj || preWorkTimeChangeObj || timeSupplementTimeChangeObj || vacationReductionTotal || hasGrandTotals"
      >
        <div>{{ hasGrandTotals ? 'Total Seite' : 'Total' }}</div>
        <div *ngIf="hasGrandTotals">Total Auswahl</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      media="(min-width: 450px)" [title]="t('employee')" [sortable]="false" *ngIf="showEmployee">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.employee?.firstName }} {{ dataItem.employee?.lastName }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="duration" [sortable]="false" [title]="t('dayDuration')" width="100">
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalWorkTimeObj || grandWorkTimeObj"
      >
        <div *ngIf="totalWorkTimeObj">{{ totalWorkTimeObj.toStringShort() }}</div>
        <div *ngIf="grandWorkTimeObj">{{ grandWorkTimeObj.toStringShort() }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="flexTimeChange" [sortable]="false" [title]="t('dayFlexTime')" width="100" *ngIf="showFlexPreWorkChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.flexTimeChangeObj)">
          <span>{{dataItem.flexTimeChangeObj?.factor < 0 && dataItem.flexTimeChangeObj?.hours == 0 ? "-" :"" }}{{ dataItem.flexTimeChangeObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.flexTimeChangeObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>

      </ng-template>
      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="totalFlexTimeChangeObj || grandFlexTimeObj"
      >
      <div *ngIf="totalFlexTimeChangeObj">{{ totalFlexTimeChangeObj.toStringShort() }}</div>
      <div *ngIf="grandFlexTimeObj">{{ grandFlexTimeObj.toStringShort() }}</div>
    </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="timeSupplementTimeChange" [sortable]="false" [title]="t('daySupplements')" width="100" *ngIf="showtimeSupplementTimeChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.timeSupplementTimeChangeObj)">
          <span>{{dataItem.timeSupplementTimeChangeObj?.factor < 0 && dataItem.timeSupplementTimeChangeObj?.hours == 0 ? "-" :"" }}{{ dataItem.timeSupplementTimeChangeObj?.hours }}</span
            ><span> h</span>
            <span> {{ (dataItem.timeSupplementTimeChangeObj?.minutes | number:'2.0')}}</span
            ><span> min</span>
        </div>

      </ng-template>
      <ng-template 
        kendoGridFooterTemplate 
        let-column
        let-dataItem
        *ngIf="timeSupplementTimeChangeObj"
      >
      <span>
        {{ timeSupplementTimeChangeObj.toStringShort() }}
      </span>
    </ng-template>
    </kendo-grid-column>
  
    <kendo-grid-column media="(min-width: 450px)"  field="preWorkTimeChange" [sortable]="false" [title]="t('dayPreWorkTime')" width="100" *ngIf="showFlexPreWorkChanges">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div [ngClass]="getTimeObjClass(dataItem?.preWorkTimeChangeObj)">
          <span >{{ dataItem.preWorkTimeChangeObj?.hours }}</span
          ><span> h</span>
          <span> {{ (dataItem.preWorkTimeChangeObj?.minutes | number:'2.0')}}</span
          ><span> min</span>
        </div>
      </ng-template>

      <ng-template
        kendoGridFooterTemplate
        let-column
        let-dataItem
        *ngIf="preWorkTimeChangeObj || grandPreWorkTimeObj"
        >
        <div *ngIf="preWorkTimeChangeObj">{{ preWorkTimeChangeObj.toStringShort() }}</div>
        <div *ngIf="grandPreWorkTimeObj">{{ grandPreWorkTimeObj.toStringShort() }}</div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="absences" [sortable]="false" [title]="t('absence')" width="160">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="hasAbsence(dataItem)" class="warning">{{ t('hasAbsence') }}</span>
        <!-- <span *ngIf="dataItem.vacationReduction != 0"> ({{dataItem.vacationReduction}} Tag)</span> -->
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column media="(min-width: 450px)"  field="vacationReduction" [sortable]="false" [title]="t('vacation')" width="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        @if(dataItem.vacationReduction != 0){
          <span>{{dataItem.vacationReduction}}</span>
        }
      </ng-template>
      <ng-template 
        kendoGridFooterTemplate 
        let-column
        let-dataItem
        *ngIf="vacationReductionTotal"
      >
      <span>
        {{ vacationReductionTotal }}
      </span>
    </ng-template>
    </kendo-grid-column>
    
    <kendo-grid-column
     media="(min-width: 450px)" [title]="t('isConfirmed')" field="isSigned" [sortable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <ng-container *ngIf="!dataItem.isConfirmed && !isAdminView && !dataItem.isSigned">
          <button
            *ngIf="!readOnly"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class="mbs mrs"
            (click)="onConfirmDay(dataItem.id)"
            [disabled]="!canConfirmDay(dataItem.date)"
            loadingIndication="/TimeEntry/confirmDay"
          >
            {{t('confirmDayButton')}}
          </button>
        </ng-container>
        <ng-container *ngIf="showSignAction && !dataItem.isSigned">
          <button
            *ngIf="canSign(dataItem)"
            kendoButton
            fillMode="solid"
            size="medium"
            rounded="medium"
            themeColor="primary"
            class="mbs mrs"
            (click)="onSignDay(dataItem.id)"
            [disabled]="!canSignDay(dataItem.date)"
            loadingIndication="/TimeEntry/signDay"
          >
            {{ t('signDayButton') }}
          </button>
        </ng-container>
        <ng-container *ngIf="dataItem.isSigned">
           {{ t('dayReport.signed')}}
        </ng-container>
        <ng-container *ngIf="!dataItem.isSigned && dataItem.isConfirmed && !(showSignAction && canSign(dataItem))">
          {{ t('dayReport.confirmed')}}
       </ng-container>
      </ng-template>
    </kendo-grid-column>

      
    <!-- Mobile View -->
    <kendo-grid-column media="(max-width: 450px)" [title]="t('dayReports')">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!-- template for mobile -->
        <kendo-formfield *ngIf="showEmployee">
          {{ dataItem.employee?.firstName }} {{ dataItem.employee?.lastName }}
        </kendo-formfield>
        <h4 [class.discontinued]="dataItem.Discontinued">
          {{ dataItem.date | date: "dd.MM.yyyy"}}
        </h4>
        <div>
          <p>{{dataItem.duration}}</p>
        </div>
        @if(showFlexPreWorkChanges){
          <div>
            <p>{{ t('dayFlexTime') }}</p>
            <div [ngClass]="getTimeObjClass(dataItem?.flexTimeChangeObj)">
              <span>{{dataItem.flexTimeChangeObj?.factor < 0 && dataItem.flexTimeChangeObj?.hours == 0 ? "-" :"" }}{{ dataItem.flexTimeChangeObj?.hours }}</span
                ><span> h</span>
                <span> {{ (dataItem.flexTimeChangeObj?.minutes | number:'2.0')}}</span
                ><span> min</span>
            </div>
          </div>
          <div>
            <p>{{ t('preWorkTimeShort') }}</p>
            <div [ngClass]="getTimeObjClass(dataItem?.preWorkTimeChangeObj)">
              <span >{{ dataItem.preWorkTimeChangeObj?.hours }}</span>
              <span> h</span>
              <span> {{ (dataItem.preWorkTimeChangeObj?.minutes | number:'2.0')}}</span>
              <span> min</span>
            </div>
          </div>
        }

        @if(dataItem.absences[0]){
          <span class="warning">{{ t('hasAbsence') }}</span>
        }
        <div>
          <ng-container *ngIf="!dataItem.isConfirmed && !isAdminView && !dataItem.isSigned">
            <button
              *ngIf="!readOnly"
              kendoButton
              fillMode="solid"
              size="medium"
              rounded="medium"
              themeColor="primary"
              class="mbs mrs"
              (click)="onConfirmDay(dataItem.id)"
              [disabled]="!canConfirmDay(dataItem.date)"
              loadingIndication="/TimeEntry/confirmDay"
            >
              {{t('confirmDayButton')}}
            </button>
          </ng-container>
          <ng-container *ngIf="showSignAction && !dataItem.isSigned">
            <button
              *ngIf="canSign(dataItem)"
              kendoButton
              fillMode="solid"
              size="medium"
              rounded="medium"
              themeColor="primary"
              class="mbs mrs"
              (click)="onSignDay(dataItem.id)"
              [disabled]="!canSignDay(dataItem.date)"
              loadingIndication="/TimeEntry/signDay"
            >
              {{ t('signDayButton') }}
            </button>
          </ng-container>
          <ng-container *ngIf="dataItem.isSigned">
             {{ t('dayReport.signed')}}
          </ng-container>
          <ng-container *ngIf="!dataItem.isSigned && dataItem.isConfirmed && !(showSignAction && canSign(dataItem))">
            {{ t('dayReport.confirmed')}}
         </ng-container>
        </div>
        
        <!-- <dl>  
          <dt>Start</dt>
          <dd>
            <kendo-maskedtextbox
              [value]="dataItem.start"
              [mask]="mask"
              [readonly]="true"
            >
            </kendo-maskedtextbox>
          </dd>
  
          <dt>Stop</dt>
          <dd>
            <kendo-maskedtextbox
              [value]="dataItem.stop"
              [mask]="mask"
              [readonly]="true"
            >
            </kendo-maskedtextbox>
          </dd>
  
          <dt>Tätigkeit</dt>
          <dd>{{dataItem.timeEntryCategory?.name ?? "-"}}</dd>
        </dl> -->
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
      <div class="text pl">{{ t('noResults') }}</div>
    </ng-template>

    <ng-template
      let-totalPages="totalPages"
      let-currentPage="currentPage"
      kendoPagerTemplate
    >
      <div class="flex flexDirRow">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons
          [buttonCount]="5"
        ></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <div>
        <label for="dayPageBtnGroup" class="mrs">{{ t('resultsPerPage') }}</label>
        <kendo-buttongroup [selection]="'single'" id="dayPageBtnGroup">
          <button
            (click)="onPageSizeChange(pageSizes.Small)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Small"
            [toggleable]="true"
          >
            {{ pageSizes.Small }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Medium)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Medium"
            [toggleable]="true"
          >
            {{ pageSizes.Medium }}
          </button>
          <button
            (click)="onPageSizeChange(pageSizes.Large)"
            kendoButton
            [selected]="gridState.pageSize === pageSizes.Large"
            [toggleable]="true"
          >
            {{ pageSizes.Large }}
          </button>
        </kendo-buttongroup>

        <button
          kendoButton
          [title]="t('refresh')"
          (click)="onGridReload()"
          icon="reload"
        ></button>
      </div>
    </ng-template>

    <ng-template kendoGridDetailTemplate let-dataItem>
        <ng-container *ngIf="dataItem.absences[0]?.id">
            <h3>{{t('absences.title')}}</h3>
            <ng-container *ngFor="let absence of dataItem.absences">
              <div class="absence mbs">
                <strong>{{ t("absences.absenceTypes." + absenceTypes[absence.absenceGroup.absenceType])}} {{absence.absenceGroup.title}}</strong>
                <span>{{t('absences.state')}}: {{ t("absences.absenceStates." + absenceStates[absence.absenceGroup.absenceState])}}</span>
                <!-- How this day's compensation was split between the two balances. -->
                @if(vm.tenantSettings?.hasOvertime && absence.absenceGroup.absenceType === absenceTypes.OvertimeCompensation){
                  <span>{{ t('absences.overtimeSplit', { overtime: overtimeHours(dataItem) | number:'1.1-1', flexTime: flexTimeHours(dataItem) | number:'1.1-1' }) }}</span>
                }
              </div>
            </ng-container>
        </ng-container>
        <h3>{{t('time-entries.title')}}</h3>
        <app-time-entry-grid
            [dayReportingObject]="dataItem"
            [timeEntries]="dataItem.timeEntries"
            [isDayReportView]="true"
            [isAdminView]="isAdminView"
            [isEditable]="isEditable"
            (onUpdateGrid)="onChangeEvent()"
        ></app-time-entry-grid>

        @if(dataItem.timeSupplementReports?.length > 0){
          <div class="divider mbs mtm"></div>

          <h3>{{ t('daySupplements') }}</h3>
          <app-time-supplement-report-grid
            [timeSupplementReports]="dataItem.timeSupplementReports"
          ></app-time-supplement-report-grid>
        }
      </ng-template>
    
  </kendo-grid>
</ng-container>
</ng-container>